import axios from 'axios'
import { getAuthHeader } from './config'

export const baseURL = '/course-category'
const prefixURL = '/api'

const getAllCategory = async () => {
  const response = await axios.get(`${prefixURL}${baseURL}`, getAuthHeader())
  return response.data
}

const createCategory = async (category) => {
  const response = await axios.post(
    `${prefixURL}${baseURL}`,
    category,
    getAuthHeader()
  )
  return response.data
}

const toggleCategoryStatus = async (categoryId) => {
  const response = await axios.patch(
    `${prefixURL}${baseURL}/toggle-status/${categoryId}`,
    {},
    getAuthHeader()
  )
  return response.data
}

const courseCategoryService = {
  getAllCategory,
  createCategory,
  toggleCategoryStatus
}

export default courseCategoryService
